import OnboardingActions from './Onboarding.actions';

const initialState = {
  profileStep: 1,
  progress: {},
  completed: 1,
  jobsLoading: false,
  fetchJobsRemaining: false,
  forecastedJobId: null,
};

function OnboardingReducer (state = initialState, action) {
  const { type = '', payload = null } = { ...action };
  switch (type) {
    case OnboardingActions.ONBOARDING_PROFILE_STEP: {
      return { ...state, profileStep: payload };
    }
    case OnboardingActions.RESET_STEP: {
      return { ...initialState };
    }
    case OnboardingActions.UPDATE_PROGRESS: {
      return { ...state, progress: { ...state.progress, ...payload } };
    }
    case OnboardingActions.SET_CURRENT_COMPLETED_STEP: {
      const current = state.completed;
      // only set completed step on the highest steps reached by the user
      if (parseFloat(payload) > parseFloat(current)) {
        localStorage.setItem('lastStep', payload.toString());
        return { ...state, completed: parseFloat(payload) };
      }
      return { ...state };
    }
    case OnboardingActions.SET_JOBS_LOADING: {
      return { ...state, jobsLoading: payload }
    }
    case OnboardingActions.FETCH_JOBS_REMAINING: {
      return { ...state, fetchJobsRemaining: payload }
    }
    case OnboardingActions.SET_FORECASTED_JOBS: {
      return { ...state, forecastedJobId: payload }
    }
    default:
      return { ...state };
  }
}

export default OnboardingReducer;
